import React from 'react';

// Diseño elegido (28 Oct, variante "B"): columna centrada como card sobre un fondo a pantalla
// completa con la foto de un edificio bajo un filtro gris banca.me (#F2F2F2), y en el header
// de todos los pasos logos, divider, fila del proyecto con miniatura rectangular y la barra de
// pasos. Las variantes anteriores siguen disponibles por URL:
// - ?layout=panel: columna + panel lateral con la foto en desktop (≥1200 px).
// - &fondo=morado | oscuro: filtro morado claro u oscuro sobre la foto en vez del gris.
// - &imagen=foto: la foto del proyecto como banda en 1f (con &nombre=foto, el nombre encima
//   en glass); &imagen=no: sin foto.
// - &miniatura=cuadrada: miniatura de 48 x 48 en vez de rectangular.
// - &glass=si: la fila del proyecto sobre una card glass hecha con la foto desenfocada.
export type PlrImageMode = 'full' | 'mini' | 'none';
export type PlrThumbShape = 'square' | 'rect';
export type PlrBackgroundTone = 'gray' | 'purple' | 'darkPurple';
export type PlrVariant = {
  centered: boolean,
  backgroundTone: PlrBackgroundTone,
  nameOnPhoto: boolean,
  image: PlrImageMode,
  thumbShape: PlrThumbShape,
  thumbGlass: boolean,
};

const imageModeFrom = (value: string | null): PlrImageMode => {
  if (value === 'no') return 'none';
  if (value === 'foto' || value === 'full') return 'full';
  return 'mini';
};

const backgroundToneFrom = (value: string | null): PlrBackgroundTone => {
  if (value === 'morado') return 'purple';
  if (value === 'oscuro') return 'darkPurple';
  return 'gray';
};

export const readPlrVariant = (): PlrVariant => {
  const query = new URLSearchParams(window.location.search);
  return {
    centered: query.get('layout') !== 'panel',
    backgroundTone: backgroundToneFrom(query.get('fondo')),
    nameOnPhoto: query.get('nombre') === 'foto',
    image: imageModeFrom(query.get('imagen')),
    thumbShape: query.get('miniatura') === 'cuadrada' ? 'square' : 'rect',
    thumbGlass: query.get('glass') === 'si',
  };
};

export type PlrLayout = {
  // Panel lateral con foto y nombre del proyecto visible en desktop.
  panel: boolean,
  // El nombre ya está sobre la foto en mobile / en la columna de desktop (tablet incluido).
  nameOnPhotoMobile: boolean,
  nameOnPhotoDesktop: boolean,
  // Variante imagen=mini: el nombre del proyecto va en la fila del header del shell.
  projectInHeader?: boolean,
  // La barra de pasos se ve en mobile (en 1f solo con la fila del proyecto en el header).
  stepBarOnMobile?: boolean,
};

export const PlrLayoutContext = React.createContext<PlrLayout>({
  panel: true, nameOnPhotoMobile: false, nameOnPhotoDesktop: false,
});

export const usePlrLayout = () => React.useContext(PlrLayoutContext);
